import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http'
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { provideRouter, withComponentInputBinding } from '@angular/router'
import { provideNgIconsConfig } from '@ng-icons/core'
import { fr } from 'date-fns/locale'
import { DateFnsConfigurationService } from 'ngx-date-fns'
import { MessageService } from 'primeng/api'
import { providePrimeNG } from 'primeng/config'
import { routes } from './app.routes'
import { client } from './core/api/client.gen'
import { provideHeyApiClient } from './core/api/client/client.gen'
import { authInterceptor } from './core/auth/auth.interceptor'
import { HeadoxTheme } from './headox-theme'
import { provideTranslateService } from '@ngx-translate/core'
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader'

const frenchConfig = new DateFnsConfigurationService()
frenchConfig.setLocale(fr)

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor]), withFetch()),
    provideHeyApiClient(client),
    providePrimeNG({
      theme: {
        preset: HeadoxTheme,
        options: {
          darkModeSelector: false,
        },
      },
      translation: {
        firstDayOfWeek: 1,
        dayNames: [$localize`Dimanche`, $localize`Lundi`, $localize`Mardi`, $localize`Mercredi`, $localize`Jeudi`, $localize`Vendredi`, $localize`Samedi`],
        dayNamesShort: [$localize`Dim`, $localize`Lun`, $localize`Mar`, $localize`Mer`, $localize`Jeu`, $localize`Ven`, $localize`Sam`],
        dayNamesMin: [$localize`Di`, $localize`Lu`, $localize`Ma`, $localize`Me`, $localize`Je`, $localize`Ve`, $localize`Sa`],
        monthNames: [$localize`Janvier`, $localize`Février`, $localize`Mars`, $localize`Avril`, $localize`Mai`, $localize`Juin`, $localize`Juillet`, $localize`Août`, $localize`Septembre`, $localize`Octobre`, $localize`Novembre`, $localize`Décembre`],
        monthNamesShort: [$localize`Jan`, $localize`Fév`, $localize`Mar`, $localize`Avr`, $localize`Mai`, $localize`Jun`, $localize`Jul`, $localize`Aoû`, $localize`Sep`, $localize`Oct`, $localize`Nov`, $localize`Déc`],
        today: $localize`Aujourd'hui`,
        clear: $localize`Effacer`,
        dateFormat: 'dd/mm/yy',
        weekHeader: $localize`Sm`,
      },
    }),
    provideNgIconsConfig({
      size: '1.4rem',
    }),
    MessageService,
    { provide: DateFnsConfigurationService, useValue: frenchConfig },
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix:"./i18n/",
        suffix: ".json"
      }),
      fallbackLang: 'fr',
    })
  ],
}
